var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMobile24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#21B5CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.188 9.67c0-.117-.043-.223-.084-.33-.173-.45-.42-.864-.666-1.276-.375-.627-.73-1.272-1.216-1.826-.268-.307-.402-.309-.725-.058-.552.426-.988.965-1.428 1.498-.356.433-.712.868-.985 1.363a.653.653 0 0 0-.078.42c.153 1.185.605 2.263 1.19 3.287 1.05 1.838 2.427 3.398 4.072 4.72 1.336 1.073 2.783 1.937 4.447 2.413.691.198 1.288.184 1.874-.32.746-.64 1.553-1.21 2.184-1.974.319-.385.313-.538-.09-.846a15.85 15.85 0 0 0-3.064-1.843c-.27-.122-.502-.072-.7.156-.283.326-.578.64-.857.968-.125.146-.256.16-.432.106a6.425 6.425 0 0 1-1.46-.663c-1.572-.96-2.673-2.3-3.261-4.058-.066-.196-.043-.337.117-.474.333-.286.656-.584.98-.878.112-.103.192-.223.182-.385zM19.006 11.49c.081 0 .163-.005.244 0 .187.011.238-.083.224-.256-.076-.969-.284-1.901-.758-2.757-1.135-2.048-2.863-3.2-5.192-3.451-.598-.065-.518-.047-.522.51-.003.424 0 .432.398.46a5.127 5.127 0 0 1 2.285.7c1.636.975 2.58 2.411 2.782 4.32.05.473.034.474.54.473z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.465 11.49c.525 0 .55-.032.456-.562l-.022-.12a4.006 4.006 0 0 0-3.433-3.269c-.431-.056-.464-.027-.465.4 0 .105.005.211 0 .317-.008.157.048.23.22.247 1.426.148 2.495 1.156 2.738 2.57.072.417.072.417.506.417z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMobile24);
export default __webpack_public_path__ + "static/media/ic_mobile_24.44a61d33d5704ac05fbfa9032722f943.svg";
export { ForwardRef as ReactComponent };